export interface AuthToken {
  maxInactiveInterval: number;
  id: number;
  email: string;
  fullName: string;
  avatarUri?: string;
  authorities: Authority[];
}

export interface AuthStatus {
  isAuthenticated: boolean;
  token?: AuthToken;
}

export enum Authority {
  ROLE_ADMIN = 'ROLE_ADMIN',
  ROLE_USER = 'ROLE_USER',
  ROLE_TECHNICIAN = 'ROLE_TECHNICIAN',
  ROLE_CLIENT_USER = 'ROLE_CLIENT_USER'
}

export function checkAdminRole(authorities?: Authority[]): boolean {
  return !!authorities && authorities.includes(Authority.ROLE_ADMIN);
}

export function checkClientRole(authorities?: Authority[]): boolean {
  return !!authorities && authorities.includes(Authority.ROLE_CLIENT_USER);
}
